import axios, { AxiosResponse } from 'axios';

// const API_BASE_URL = process.env.VITE_BASE_URL;
const API_BASE_URL = import.meta.env.VITE_BASE_URL;

interface ApiResponse<T> {
  data: T;
  statusCode: number;
}

interface ApiError {
  data: [];
  message: string;
  statusCode: number;
  // data: []
}

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const api_form = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});


// Interceptor để thêm Authorization token vào header
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Hoặc sử dụng sessionStorage hoặc từ một nguồn khác
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


export const fetchData = async <T>(endpoint: string): Promise<ApiResponse<T> | ApiError> => {
  try {
    const response: AxiosResponse<T> = await api.get(endpoint);
    return { data: response.data, statusCode: response.status };
  } catch (error: any) {
    const status = error.response?.status || 500;
    
    // Kiểm tra lỗi 401 tại đây
    if (status === 401) {
      window.location.href = '/sign-in';
      return { data: [], message: 'Unauthorized', statusCode: 401 };
    }
    return { data: [], message: error.response?.data?.message || 'Unknown error', statusCode: error.response?.status || 500};
  }
};

export const postData = async <T>(endpoint: string, data: T): Promise<ApiResponse<T> | ApiError> => {
  try {
    const response: AxiosResponse<T> = await api.post(endpoint, data);
    return { data: response.data, statusCode: response.status };
  } catch (error: any) {
    const status = error.response?.status || 500;
    
    // Kiểm tra lỗi 401 tại đây
    if (status === 401) {
      window.location.href = '/sign-in';
      return { data: [], message: 'Unauthorized', statusCode: 401 };
    }
    return { data: [], message: error.response?.data?.message || 'Unknown error', statusCode: error.response?.status || 500 };
  }
};

export const patchData = async <T>(endpoint: string, data: T): Promise<ApiResponse<T> | ApiError> => {
  try {
    const response: AxiosResponse<T> = await api.patch(endpoint, data);
    return { data: response.data, statusCode: response.status };
  } catch (error: any) {
    const status = error.response?.status || 500;
    
    // Kiểm tra lỗi 401 tại đây
    if (status === 401) {
      window.location.href = '/sign-in';
      return { data: [], message: 'Unauthorized', statusCode: 401 };
    }
    return { data: [], message: error.response?.data?.message || 'Unknown error', statusCode: error.response?.status || 500 };
  }
};

export const deleteData = async <T>(endpoint: string): Promise<ApiResponse<T> | ApiError> => {
  try {
    const response: AxiosResponse<T> = await api.delete(endpoint);
    return { data: response.data, statusCode: response.status };
  } catch (error: any) {
    const status = error.response?.status || 500;
    
    // Kiểm tra lỗi 401 tại đây
    if (status === 401) {
      window.location.href = '/sign-in';
      return { data: [], message: 'Unauthorized', statusCode: 401 };
    }
    return { data: [], message: error.response?.data?.message || 'Unknown error', statusCode: error.response?.status || 500};
  }
};

export const postDataForm = async <T>(endpoint: string, data: FormData): Promise<ApiResponse<T> | ApiError> => {
  try {
    const response: AxiosResponse<T> = await api_form.post(endpoint, data);
  
    return { data: response.data, statusCode: response.status };
  } catch (error: any) {
    const status = error.response?.status || 500;
    
    // Kiểm tra lỗi 401 tại đây
    if (status === 401) {
      window.location.href = '/sign-in';
      return { data: [], message: 'Unauthorized', statusCode: 401 };
    }
    return { 
      data: [], 
      message: error.response?.data?.message || 'Unknown error', 
      statusCode: error.response?.status || 500 
    };
  }
};

export const downloadTemplateBaoCaoExcel = async (id: any, body_: any, fileName: any) => {
  const uri = `${API_BASE_URL}templater/xlsx/${id}/file`
  try {
    // Gửi yêu cầu POST với body và nhận phản hồi dưới dạng blob
    const response = await fetch(uri, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Thêm các header khác nếu cần thiết
      },
      body: body_ // Chuyển đổi body thành JSON nếu cần
    })

    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    const blob = await response.blob() // Nhận dữ liệu dưới dạng blob
    // Tạo URL từ blob và tải file
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${fileName}.xlsx`)// Đặt tên file cho việc tải xuống
    document.body.appendChild(link)
    link.click()
    link.remove()
    // Giải phóng URL blob
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Error downloading file:', error)
    // Xử lý lỗi nếu cần
  }
}
export const downloadTemplateBaoCaoWord = async (id: any, body_: any, fileName: any) => {
  const uri = `${API_BASE_URL}templater/docx/${id}/file`
  try {
    // Gửi yêu cầu POST với body và nhận phản hồi dưới dạng blob
    const response = await fetch(uri, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Thêm các header khác nếu cần thiết
      },
      body: body_ // Chuyển đổi body thành JSON nếu cần
    })

    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    const blob = await response.blob() // Nhận dữ liệu dưới dạng blob
    // Tạo URL từ blob và tải file
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${fileName}.docx`)// Đặt tên file cho việc tải xuống
    document.body.appendChild(link)
    link.click()
    link.remove()
    // Giải phóng URL blob
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Error downloading file:', error)
    // Xử lý lỗi nếu cần
  }
}